import './Report20XX.css';

const report2025 = () => {
  return (
    <div className='Report20XX_wrapper'>
      {/* THE CHAMP */}
      <div className='Report20XX_header'>The King Is Dead??!!</div>
      <div className='Report20XX_champPlaque'>
        <img
          className='Report20XX_champPlaquePic'
          src='/images/2025/2025Plaque.JPG'
          alt='2025 Plaque'
        />
      </div>
      <div className='Report20XX_champTextShrink'>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;We had a smaller group in 2025, with Kyle and
          Randy not able to make it, and none of the usual pinch-hitters to
          round out the numbers. We still managed to keep the best streak alive:
          someone new won their first shirt. This year it was Dalton, and it is
          nuts that he had never made a Final before.
        </p>
        <br />
        <p>
          One of the other epic streaks did come to an end this year: Andrew
          Emerick failed to make the Final for the first time...ever. He
          completed a week's wardrobe. Your seventh shirt is green and it's your
          last. Looks like he will have to wait at least another year for that
          Top Toad shower curtain!
        </p>
        <br />
        <p>
          This core group produced another first-time champ, our EIGHTH in NINE
          years: Chris Wildes, who fittingly won the Final in a match of Ticket
          to Ride World Maps. He joins Randy and Rodney as our only players so
          far to have both a plaque and a mug. Christy got "mugged" this year.
          It's coming for you soon.
        </p>
      </div>
      <div className='Report20XX_champPic'>
        <img
          className='Report20XX_champPlayerPic'
          src='/images/2025/2025Champ.JPG'
          alt='Chris Wildes displays plaque'
        />
      </div>
      <div className='Report20XX_padding' />
      {/* THE TOADS */}
      <div className='Report20XX_header'>The Toads of 2025</div>
      <div className='Report20XX_toads'>
        <img
          className='Report20XX_toadsPic'
          src='/images/2025/2025Group.JPG'
          alt='The 2025 Top Toads Group'
        />
      </div>
      <ul className='Report20XX_toadsText'>
        <li>Christy Applegate (MD)</li>
        <li>Rodney Bacigalupo (AR)</li>
        <li>Aaron Blair (MD)</li>
        <li>Andrew Emerick (CT)</li>
        <li>Andy Latto (MA)</li>
        <li>Marcy Morelli (PA)</li>
        <li>Rob Murray (NJ)</li>
        <li>Antony Saccenti (MD)</li>
        <li>Donte Saccenti (MD)</li>
        <li>Preston Saccenti (MD)</li>
        <li>Scott Saccenti (MD)</li>
        <li>Dalton Versak (PA)</li>
        <li>Chad Weaver (PA)</li>
        <li>Chris Wildes (DC)</li>
        <li>Joe Yaure (RI)</li>
        <li>Eugene Yee (MD)</li>
      </ul>
      <div className='Report20XX_padding' />
      {/* THE GAMES */}
      <div className='Report20XX_header'>The Games of 2025</div>
      <ul className='Report20XX_gamesText'>
        <li>7 Wonders</li>
        <li>Alhambra</li>
        <li>Carcassonne</li>
        <li>Castles of Mad King Ludwig</li>
        <li>Coloretto</li>
        <li>Egizia</li>
        <li>For Sale</li>
        <li>Incan Gold</li>
        <li>Ingenious</li>
        <li>Istanbul</li>
        <li>Las Vegas</li>
        <li>Luxor</li>
        <li>Medici</li>
        <li>Puerto Rico</li>
        <li>Ra</li>
        <li>Saint Petersburg</li>
        <li>Splendor</li>
        <li>Stone Age</li>
        <li>Thurn & Taxis</li>
        <li>Ticket to Ride</li>
        <li>Ticket to Ride: World Maps</li>
        <li>Vegas Showdown</li>
      </ul>
      <div className='Report20XX_games'>
        <img
          className='Report20XX_gamesPic'
          src='/images/2025/2025Games.JPG'
          alt='Ticket to Ride Italy, played in the Final'
        />
      </div>
      <div className='Report20XX_extraPics'>
        <img
          className='Report20XX_extraPic1'
          src='/images/2025/2025Splendor.JPG'
          alt='Eugene Yee, Andrew Emerick, Marcy Morelli and Aaron Blair play Splendor'
        />
        <img
          className='Report20XX_extraPic2'
          src='/images/2025/2025Pria.JPG'
          alt='Pria Saccenti, Dalton Versak, Rodney Bacigalupo, Preston and Antony Saccenti play Incan Gold'
        />
        <img
          className='Report20XX_extraPic3'
          src='/images/2025/2025TentCity.JPG'
          alt='Tents set up in the basement'
        />
        <img
          className='Report20XX_extraPic4'
          src='/images/2025/2025Vegas.JPG'
          alt='Christy Applegate, Rodney Bacigalupo and Aaron Blair play Vegas Showdown'
        />
        <img
          className='Report20XX_extraPic5'
          src='/images/2025/2025BalconyView.JPG'
          alt='Gaming area pictured from balcony above'
        />
        <img
          className='Report20XX_extraPic6'
          src='/images/2025/2025GroupGag.JPG'
          alt='2025 Top Toad Group Gag Shot'
        />
        <img
          className='Report20XX_extraPic7'
          src='/images/2025/2025LunchBreak.JPG'
          alt='Antony Saccenti, Dalton Versak, Joe Yaure and Preston Saccenti break for a fried-chicken lunch'
        />
        <img
          className='Report20XX_extraPic8'
          src='/images/2025/2025MarsGame.JPG'
          alt='Rob Murray, Chad Weaver, Donte Saccenti, Dalton Versak and Antony Saccenti playing Terraforming Mars'
        />
        <img
          className='Report20XX_extraPic9'
          src='/images/2025/2025PuertoBid.JPG'
          alt='Bidding sheet for an upcoming game of Puerto Rico'
        />
        <img
          className='Report20XX_extraPic10'
          src='/images/2025/2025Buckee.JPG'
          alt='Dalton Versak, Buckee and Marcy Morelli play Saint Petersburg'
        />
        <img
          className='Report20XX_extraPic11'
          src='/images/2025/2025Turkey.JPG'
          alt='2025 Top Toad Turkey'
        />
        <img
          className='Report20XX_extraPic12'
          src='/images/2025/2025FinalFour.JPG'
          alt='The 2025 Top Toad Finalists: Chris Wildes, Scott Saccenti, Rodney Bacigalupo and Dalton Versak'
        />
      </div>
    </div>
  );
};

export default report2025;
